"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const get_1 = __importDefault(require("lodash/get"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const turf = __importStar(require("@turf/turf"));
const Status = __importStar(require("chaire-lib-common/lib/utils/Status"));
const GenericPlace_1 = require("chaire-lib-common/lib/utils/objects/GenericPlace");
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const SaveUtils_1 = __importDefault(require("chaire-lib-common/lib/services/objects/SaveUtils"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const ConversionUtils_1 = require("chaire-lib-common/lib/utils/geometry/ConversionUtils");
const RoutingServiceManager_1 = __importDefault(require("chaire-lib-common/lib/services/routing/RoutingServiceManager"));
const MathUtils_1 = require("chaire-lib-common/lib/utils/MathUtils");
/**
 * A group of stop signs or platforms allowing direct connections between lines.
 * A node can be part of a station or not.
 * Can include stops (when designing precise network operations) or not (when planning or designing).
 */
class Node extends GenericPlace_1.GenericPlace {
    constructor(attributes = {}, isNew, collectionManager) {
        super(attributes, isNew, collectionManager);
        this.updateHistoryCallback = this.updateRoutingRadiusInPixels;
        this.getRoutingRadiusPixelsAtMaxZoom();
    }
    _prepareAttributes(attributes) {
        attributes.routing_radius_meters = (0, get_1.default)(attributes, 'routing_radius_meters', Preferences_1.default.get('transit.nodes.defaultRoutingRadiusMeters', 50));
        attributes.default_dwell_time_seconds = (0, get_1.default)(attributes, 'default_dwell_time_seconds', Preferences_1.default.get('transit.nodes.defaultDwellTimeSeconds'));
        return super._prepareAttributes(attributes);
    }
    // TODO: Move out of this class
    hasPaths() {
        var _a;
        const paths = ((_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('paths').getFeatures()) || [];
        const nodeId = this.get('id');
        const pathsCount = paths.length;
        for (let i = 0; i < pathsCount; i++) {
            const path = paths[i];
            if (path.properties.nodes.includes(nodeId)) {
                return true;
            }
        }
        return false;
    }
    // TODO: Move out of this class
    getPaths() {
        var _a;
        const paths = ((_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('paths').getFeatures()) || [];
        const nodeId = this.get('id');
        const pathsCount = paths.length;
        const pathsUsingNode = [];
        for (let i = 0; i < pathsCount; i++) {
            const path = paths[i];
            if (path.properties.nodes.includes(nodeId)) {
                pathsUsingNode.push(path.get('id'));
            }
        }
        return pathsUsingNode;
    }
    getRoutingRadiusPixelsAtMaxZoom() {
        const latitude = this._attributes.geography.coordinates[1];
        if (latitude) {
            this._attributes.data.routingRadiusPixelsAtMaxZoom = (0, ConversionUtils_1.metersToMapboxPixelsAtMaxZoom)(this._attributes.routing_radius_meters, latitude);
        }
        else {
            this._attributes.data.routingRadiusPixelsAtMaxZoom = null;
        }
    }
    getRadiusPixelsAtMaxZoom(radius) {
        const latitude = this._attributes.geography.coordinates[1];
        return (0, ConversionUtils_1.metersToMapboxPixelsAtMaxZoom)(radius, latitude);
    }
    toGeojson() {
        const _250mRadiusPixelsAtMaxZoom = this.getRadiusPixelsAtMaxZoom(250) || 1;
        return {
            id: this._attributes.integer_id,
            geometry: this._attributes.geography,
            type: 'Feature',
            properties: Object.assign(Object.assign({}, this._attributes), { _routingRadiusPixelsAtMaxZoom: this._attributes.data.routingRadiusPixelsAtMaxZoom, _250mRadiusPixelsAtMaxZoom: _250mRadiusPixelsAtMaxZoom, _500mRadiusPixelsAtMaxZoom: _250mRadiusPixelsAtMaxZoom * 2, _750mRadiusPixelsAtMaxZoom: _250mRadiusPixelsAtMaxZoom * 3, _1000mRadiusPixelsAtMaxZoom: _250mRadiusPixelsAtMaxZoom * 4 })
            // TODO: we should filter out transferable nodes in data here
        };
    }
    validate(nameIsRequired = Preferences_1.default.get('transit.nodes.nameIsRequired')) {
        this._isValid = true;
        this.errors = [];
        if (nameIsRequired && (0, LodashExtensions_1._isBlank)(this._attributes.name)) {
            this._isValid = false;
            this.errors.push('transit:transitNode:errors:NameIsRequired');
        }
        const routingRadiusMeters = this._attributes.routing_radius_meters;
        if (isNaN(routingRadiusMeters) || routingRadiusMeters > 200 || routingRadiusMeters < 5) {
            this._isValid = false;
            this.errors.push('transit:transitNode:errors:RoutingRadiusMetersIsInvalid');
        }
        const dwellTimeSeconds = this._attributes.default_dwell_time_seconds;
        if (isNaN(dwellTimeSeconds) || dwellTimeSeconds < 0) {
            this._isValid = false;
            this.errors.push('transit:transitNode:errors:DefaultDwellTimeSecondsIsInvalid');
        }
        return this._isValid;
    }
    lat() {
        return this._attributes.geography.coordinates[1];
    }
    lon() {
        return this._attributes.geography.coordinates[0];
    }
    updateRoutingRadiusInPixels() {
        const routingRadius = this._attributes.routing_radius_meters;
        const geography = this._attributes.geography;
        const routingRadiusInPixels = (0, ConversionUtils_1.metersToMapboxPixelsAtMaxZoom)(routingRadius, geography.coordinates[1]);
        this._attributes.data.routingRadiusPixelsAtMaxZoom = routingRadiusInPixels;
        return routingRadiusInPixels;
    }
    //TODO: Implement this function, or remove it.
    calculateOdTripsWeight(_dataSourceId) {
        // Nothing to do. Why?
    }
    getOsrmRoutingTableFrom(mode, allNodes) {
        return __awaiter(this, void 0, void 0, function* () {
            const routingService = RoutingServiceManager_1.default.getRoutingServiceForEngine('engine');
            return yield routingService.tableFrom({ mode, origin: this.toGeojson(), destinations: allNodes });
        });
    }
    travelTimesAndDistancesToAllNodes() {
        return __awaiter(this, arguments, void 0, function* (mode = 'driving') {
            var _a;
            const allNodes = ((_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes').getFeatures()) || [];
            const resultsByNodeId = {};
            const routingResultJson = yield this.getOsrmRoutingTableFrom(mode, allNodes);
            const durations = (0, get_1.default)(routingResultJson, 'durations');
            const distances = (0, get_1.default)(routingResultJson, 'distances');
            for (let i = 0, count = allNodes.length; i < count; i++) {
                const node = allNodes[i];
                const travelTimeSeconds = (0, get_1.default)(durations, `[${i}]`, null);
                if (!(0, LodashExtensions_1._isBlank)(travelTimeSeconds)) {
                    const distanceMeters = (0, get_1.default)(distances, `[${i}]`, null);
                    resultsByNodeId[node.properties.id] = {
                        travelTimeSeconds,
                        distanceMeters
                    };
                }
            }
            return resultsByNodeId;
        });
    }
    travelTimesAndDistancesFromAllNodes() {
        return __awaiter(this, arguments, void 0, function* (mode = 'driving') {
            var _a;
            const allNodes = ((_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes').getFeatures()) || [];
            const resultsByNodeId = {};
            // TODO: Replace with RoutingService function call, to not directly depend on OSRM
            const routingService = RoutingServiceManager_1.default.getRoutingServiceForEngine('engine');
            const routingResultJson = yield routingService.tableTo({
                mode,
                origins: allNodes,
                destination: this.toGeojson()
            });
            const durations = (0, get_1.default)(routingResultJson, 'durations');
            const distances = (0, get_1.default)(routingResultJson, 'distances');
            for (let i = 0, count = allNodes.length; i < count; i++) {
                const node = allNodes[i];
                const travelTimeSeconds = (0, get_1.default)(durations, `[${i}]`, null);
                if (!(0, LodashExtensions_1._isBlank)(travelTimeSeconds)) {
                    const distanceMeters = (0, get_1.default)(distances, `[${i}]`, null);
                    resultsByNodeId[node.properties.id] = {
                        travelTimeSeconds,
                        distanceMeters
                    };
                }
            }
            return resultsByNodeId;
        });
    }
    getIsochroneGeojson(_socket_1) {
        return __awaiter(this, arguments, void 0, function* (_socket, _mode = 'walking', _durationsMinutes = [5, 10, 15, 20]) {
            return {};
            /* TODO Disabled since valhalla is broken
        const points = [this.toGeojson()];
        const params = {
          points,
          times : durationsMinutes,
          mode
        };
        return new Promise(function(resolve, reject) {
          if (!socket) {
            valhallaService.isochrone(params).then(function(response) {
              if (!response.error)
              {
                resolve(response);
              }
              else
              {
                reject(response.error);
              }
            }).catch(function(error) {
              console.error(error);
            });
          }
          else
          {
            socket.emit('service.valhallaRouting.isochrone', params, function(response) {
              if (!response.error)
              {
                resolve(response);
              }
              else
              {
                reject(response.error);
              }
            });
          }
        }.bind(this));*/
        });
    }
    toString(showId = true) {
        const name = this.get('name');
        const code = this.get('code');
        if (name && code) {
            return `${name} [${code}]`;
        }
        else if (name) {
            return name;
        }
        else if (code) {
            return code;
        }
        return showId ? this._attributes.id : null;
    }
    countStops() {
        return (this.attributes.data.stops || []).length;
    }
    getStopsGeojson() {
        const stopsData = this.attributes.data.stops || [];
        const stopsGeojson = [];
        for (let i = 0, count = stopsData.length; i < count; i++) {
            const stop = stopsData[i];
            const geojson = stop ? stop.geography : null;
            if (geojson) {
                stopsGeojson.push({
                    id: i + 1,
                    geometry: geojson,
                    type: 'Feature',
                    properties: Object.assign({}, stop)
                });
            }
        }
        return stopsGeojson;
    }
    updateRadiusFromStops() {
        const stopsData = this.attributes.data.stops || [];
        const maxStopDistance = stopsData.reduce((maxDistance, stopData) => Math.max(maxDistance, turf.distance(this.attributes.geography, stopData.geography, { units: 'meters' })), 0);
        this.attributes.routing_radius_meters = Math.max((0, MathUtils_1.ceilToPositiveInteger)(maxStopDistance), this.attributes.routing_radius_meters);
        this._updateHistory();
    }
    addStop(stopAttributes, options = {}) {
        this.updateStop(stopAttributes, options);
    }
    updateStop(stopAttributes, options = {}) {
        var _a;
        const stopsData = this.attributes.data.stops || [];
        const newStopId = stopAttributes.id;
        const gtfsStopId = (_a = stopAttributes.data.gtfs) === null || _a === void 0 ? void 0 : _a.stop_id;
        const existingStopIndex = stopsData.findIndex((stopData) => {
            var _a, _b;
            return (stopData.id && stopData.id === newStopId) ||
                ((0, isEqual_1.default)(stopData.geography, stopAttributes.geography) &&
                    stopData.code === stopAttributes.code &&
                    stopData.name === stopAttributes.name &&
                    ((_b = (_a = stopData.data) === null || _a === void 0 ? void 0 : _a.gtfs) === null || _b === void 0 ? void 0 : _b.stop_id) === gtfsStopId);
        });
        if (existingStopIndex >= 0) {
            stopsData[existingStopIndex] = stopAttributes;
        }
        else {
            stopsData.push(stopAttributes);
            this.attributes.data.stops = stopsData;
        }
        if (options.updateCentroid === true) {
            this.updateCentroidFromStops();
        }
        this.updateRadiusFromStops();
        return newStopId;
    }
    getStop(stopId) {
        const stopsData = this.attributes.data.stops || [];
        return stopsData.find((stop) => stop.id === stopId);
    }
    removeStop(stopId) {
        const stopsData = this.attributes.data.stops || [];
        let deleteStopIndex = null;
        for (let i = 0, count = stopsData.length; i < count; i++) {
            if (stopsData[i].id === stopId) {
                deleteStopIndex = i;
                break;
            }
        }
        if (deleteStopIndex !== null && deleteStopIndex >= 0) {
            stopsData.splice(deleteStopIndex, 1);
            this.setData('stops', stopsData);
            return stopId;
        }
        else {
            return null;
        }
    }
    updateCentroidFromStops() {
        const stopsData = this.attributes.data.stops || [];
        if (stopsData.length > 1) {
            const stopsFeatures = [];
            for (let i = 0, count = stopsData.length; i < count; i++) {
                const stop = stopsData[i];
                const geometry = stop.geography;
                if (geometry && geometry.coordinates) {
                    stopsFeatures.push({
                        type: 'Feature',
                        geometry: geometry,
                        properties: {}
                    });
                }
            }
            if (stopsFeatures.length > 1) {
                const featureCollection = {
                    type: 'FeatureCollection',
                    features: stopsFeatures
                };
                const centroid = turf.center(featureCollection);
                this.set('geography', centroid.geometry);
            }
        }
    }
    static fromGeojson(geojsonFeature, isNew = false, collectionManager) {
        const node = new Node(Object.assign(Object.assign({}, geojsonFeature.properties), { geography: geojsonFeature.geometry }), isNew, collectionManager);
        node.getRoutingRadiusPixelsAtMaxZoom();
        return node;
    }
    static symbol() {
        return 'q';
    }
    delete(socket) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _reject) => {
                var _a;
                SaveUtils_1.default.delete(this, socket, 'transitNode', (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes')).then((response) => {
                    var _a, _b;
                    if (Status.isStatusOk(response) &&
                        Status.unwrap(response).id !== undefined &&
                        ((_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes'))) {
                        (_b = this._collectionManager) === null || _b === void 0 ? void 0 : _b.get('nodes').updateSpatialIndex();
                    }
                    resolve(response);
                });
            });
        });
    }
    save(socket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasChanged() || this.isNew()) {
                return new Promise((resolve, reject) => {
                    this.updateRoutingRadiusInPixels();
                    const shouldUpdateGeometries = this.hasChangedGeography();
                    socket.emit('transitNode.save', this.attributes, shouldUpdateGeometries, (responseStatus) => {
                        var _a;
                        if (Status.isStatusOk(responseStatus)) {
                            this._wasFrozen = this.attributes.is_frozen === true;
                            const collection = (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes');
                            if (collection) {
                                if ((collection === null || collection === void 0 ? void 0 : collection.getIndex(this.attributes.id)) >= 0) {
                                    collection.updateById(this.attributes.id, this);
                                }
                                else {
                                    collection.add(this);
                                }
                                if (shouldUpdateGeometries) {
                                    collection.updateSpatialIndex();
                                }
                            }
                            resolve(Status.unwrap(responseStatus));
                        }
                        else {
                            reject(responseStatus.error);
                        }
                    });
                });
            }
            else {
                return 0;
            }
        });
    }
    saveInMemory() {
        var _a;
        SaveUtils_1.default.saveInMemory(this, (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes'));
    }
    deleteInMemory() {
        var _a;
        SaveUtils_1.default.deleteInMemory(this, (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes'));
    }
    saveToCache(socket) {
        return new Promise((resolve, reject) => {
            socket.emit('transitNode.saveCache', this._attributes, (response) => {
                if (!response.error) {
                    resolve(response);
                }
                else {
                    reject(response.error);
                }
            });
        });
    }
    loadFromCache(socket) {
        return new Promise((resolve, reject) => {
            socket.emit('transitNode.loadCache', this.get('id'), (0, get_1.default)(this._attributes, 'data.customCachePath'), (response) => {
                if (!response.error) {
                    //console.log(response);
                    // we need to use set to trigger history change before setting to edit:
                    if (response && response.node && response.node.data) {
                        if (response.node.data.transferableNodes) {
                            this._attributes.data.transferableNodes = response.node.data.transferableNodes;
                        }
                        if (response.node.data.accessiblePlaces) {
                            this._attributes.data.accessiblePlaces = response.node.data.accessiblePlaces;
                        }
                        if (response.node.data.accessibleResidentialEntrances) {
                            this._attributes.data.accessibleResidentialEntrances =
                                response.node.data.accessibleResidentialEntrances;
                        }
                    }
                    response.node = this;
                    resolve(response);
                }
                else {
                    reject(response.error);
                }
            });
        });
    }
    static getPluralName() {
        return 'nodes';
    }
    static getCapitalizedPluralName() {
        return 'Nodes';
    }
    static getDisplayName() {
        return Node.displayName;
    }
}
exports.Node = Node;
Node.displayName = 'Node';
exports.default = Node;
//# sourceMappingURL=Node.js.map